// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import SmallDisplayCategoryFileContextMenu from '@/components/small-display/SmallDisplayCategoryFileContextMenu.vue';
import SmallDisplayCategoryUserContextMenu from '@/components/small-display/SmallDisplayCategoryUserContextMenu.vue';
import SmallDisplayCreateJoinModal from '@/components/small-display/SmallDisplayCreateJoinModal.vue';
import SmallDisplayFileContextMenu from '@/components/small-display/SmallDisplayFileContextMenu.vue';
import SmallDisplayUserContextMenu from '@/components/small-display/SmallDisplayUserContextMenu.vue';

export {
  SmallDisplayCategoryFileContextMenu,
  SmallDisplayCategoryUserContextMenu,
  SmallDisplayCreateJoinModal,
  SmallDisplayFileContextMenu,
  SmallDisplayUserContextMenu,
};
